const getGalleryFilters = () => {
  return [
    { key: "all", label: "All", value: "all" },
    { key: "salesforce data cloud", label: "Data Cloud", value: "salesforce data cloud series" },
    { key: "salesforce live", label: "Live Sessions", value: "salesforce live" },
  ];
};

export { getGalleryFilters };